export const openCloseLoading = state => {
    return {
        type: "STATE_STATUS_LOADING",
        payload: state
    };
};